import { MARQUEE_ITEMS } from "@/lib/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-lg font-medium text-kryvo-ink/60 sm:text-xl">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-kryvo-lime" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    className="overflow-hidden border-y border-kryvo-green/10 bg-white py-5"
    aria-hidden="true"
    data-testid="services-marquee"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
